import React from "react";
import { Link } from "react-router-dom";
import data from "../data/imageData.json";
import "./styles/Gallery.css";
import ResponsiveImage from "./ResponsiveImage";

const Gallery = () => {
  return (
    <div className="albumsGrid">
      {data.albums.map((album) => {
        const cover = album.cover || album.images[0]?.url;
        return (
          <Link
            key={album.slug}
            to={`/portfolio/${album.slug}`}
            className="albumCard"
          >
            <ResponsiveImage
              className="albumCover"
              src={cover}
              alt={album.name}
              sizes="(max-width: 600px) calc(100vw - 40px), (max-width: 900px) 50vw, (max-width: 1200px) 33vw, 25vw"
            />
            <div className="albumMeta">
              <h2 className="albumCardTitle">{album.name}</h2>
              <span className="albumCount">{album.images.length} imagini</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default Gallery;
